import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useApp } from '../contexts/AppContext';
import Button from '../components/common/Button';
import Input from '../components/common/Input';
import Modal from '../components/common/Modal';
import DatePicker from '../components/common/DatePicker';
import AbaProtegida from '../components/common/AbaProtegida';
import CargasService from '../services/cargasServiceAPI';
import { SolicitacoesService } from '../services/solicitacoesService';
import NotificacoesService from '../services/notificacoesService';
import { ConfiguracoesService } from '../services/configuracoesService';
import ConferentesService, { Conferente } from '../services/conferentesServiceAPI';
import { AuditService } from '../services/auditService';
import { DocumentosService } from '../services/documentosService';
import { apiRequest } from '../config/api';
import { TipoAcaoAudit, TipoNotificacao } from '../types';

// Tipo para Carga
type Carga = {  
  id: string;
  codigo: string;
  fornecedor: string;
  peso: number;
  volume: number;
  data: string;
  status: string;
  criadoEm: string;
  criadoPor: string;
  filial: string;
  mercadorias: string;
      tipoCarga: string;
      tipoProduto: string;
  conferente: string;
  ordemChegada: number | null;
  horaOrdemChegada: string | null;
  nf: string;
  dataProgramada: string;
  idSolicitacao: string | null;
  solicitante: string | null;
  dataSolicitacao: string | null;
  statusSolicitacao: string | null;
  tipoProdutoSolicitacao: string | null;
  documentos: Array<{ nome: string; url: string }>;
  pedidos: Array<{ numero: string; valor: number }>;
  observacoes: string;
  ocorrencia: string;
  arquivoOcorrencia: string | null;
  prioridade: number; // 1-5
};

// Dados mock para cargas (baseado no sistema antigo)
const mockCargas: Carga[] = [
  {
    id: '1775677744920',
    codigo: 'CARGA001',
    fornecedor: 'Vigor Alimentos',
    peso: 28000.0,
    volume: 4667,
    data: '2026-04-17',
    status: 'Não chegou',
    criadoEm: '2026-04-16T21:00:00Z',
    criadoPor: 'Thiago Vital',
    filial: 'FILIAL_1',
    mercadorias: 'Resina, Polipropileno',
    tipoCarga: 'PALETIZADA',
    tipoProduto: 'SECOS',
    conferente: 'Não definido',
    ordemChegada: null,
    horaOrdemChegada: null,
    nf: 'Não informada',
    dataProgramada: '2026-04-16T21:00:00Z',
    idSolicitacao: 'SOL-MNQBD8KY-Q32EU',
    solicitante: 'Não informado',
    dataSolicitacao: null,
    statusSolicitacao: 'Agendamento realizado',
    tipoProdutoSolicitacao: 'Não informado',
    documentos: [],
    pedidos: [],
    observacoes: 'Nenhuma observação',
    ocorrencia: '',
    arquivoOcorrencia: null,
    prioridade: 3
  },
  {
    id: '2',
    codigo: 'CARGA002',
    fornecedor: 'Transportadora XYZ',
    peso: 2300.0,
    volume: 3.1,
    data: '2026-04-17',
    status: 'Chegou',
    criadoEm: '2026-04-16T14:30:00Z',
    criadoPor: 'João',
    filial: 'FILIAL_1',
    mercadorias: 'PVC, PET',
    tipoCarga: 'Carreta',
    tipoProduto: 'Plásticos',
    conferente: 'Carlos',
    ordemChegada: 1,
    horaOrdemChegada: '08:15',
    nf: 'NF-12345',
    dataProgramada: '2026-04-17T08:00:00Z',
    idSolicitacao: 'SOL-ABC123-DEF',
    solicitante: 'Maria Silva',
    dataSolicitacao: '2026-04-15T10:00:00Z',
    statusSolicitacao: 'Aprovado',
    tipoProdutoSolicitacao: 'Plásticos',
    documentos: [{ nome: 'nota_fiscal.pdf', url: '#' }],
    pedidos: [{ numero: 'PED-001', valor: 15000 }],
    observacoes: 'Carga com prioridade alta',
    ocorrencia: '',
    arquivoOcorrencia: null,
    prioridade: 4
  },
  {
    id: '3',
    codigo: 'CARGA003',
    fornecedor: 'Logística Rápida',
    peso: 1800.75,
    volume: 2.8,
    data: '2026-04-16',
    status: 'Descarregando',
    criadoEm: '2026-04-16T10:15:00Z',
    criadoPor: 'Maria',
    filial: 'FILIAL_2',
    mercadorias: 'Polietileno',
    tipoCarga: 'Caminhão Toco',
    tipoProduto: 'Plásticos',
    conferente: 'Ana',
    ordemChegada: 2,
    horaOrdemChegada: '09:30',
    nf: 'NF-67890',
    dataProgramada: '2026-04-16T09:00:00Z',
    idSolicitacao: 'SOL-XYZ789-GHI',
    solicitante: 'Pedro Santos',
    dataSolicitacao: '2026-04-14T15:30:00Z',
    statusSolicitacao: 'Em andamento',
    tipoProdutoSolicitacao: 'Plásticos',
    documentos: [{ nome: 'romaneio.pdf', url: '#' }, { nome: 'nota_fiscal.pdf', url: '#' }],
    pedidos: [],
    observacoes: 'Mercadoria frágil',
    ocorrencia: '',
    arquivoOcorrencia: null,
    prioridade: 5
  },
  {
    id: '4',
    codigo: 'CARGA004',
    fornecedor: 'Transportadora Express',
    peso: 2500.0,
    volume: 3.5,
    data: '2026-04-17',
    status: 'Pronta para receber',
    criadoEm: '2026-04-17T09:00:00Z',
    criadoPor: 'Pedro',
    filial: 'FILIAL_1',
    mercadorias: 'Polipropileno, Aditivos',
    tipoCarga: 'Carreta',
    tipoProduto: 'Plásticos',
    conferente: 'João',
    ordemChegada: 3,
    horaOrdemChegada: '10:00',
    nf: 'NF-11111',
    dataProgramada: '2026-04-17T10:00:00Z',
    idSolicitacao: null,
    solicitante: null,
    dataSolicitacao: null,
    statusSolicitacao: null,
    tipoProdutoSolicitacao: null,
    documentos: [],
    pedidos: [{ numero: 'PED-002', valor: 20000 }],
    observacoes: '',
    ocorrencia: '',
    arquivoOcorrencia: null,
    prioridade: 2
  },
  {
    id: '5',
    codigo: 'CARGA005',
    fornecedor: 'Distribuidora Norte',
    peso: 1200.0,
    volume: 1.8,
    data: '2026-04-16',
    status: 'Finalizado',
    criadoEm: '2026-04-16T08:00:00Z',
    criadoPor: 'Lucas',
    filial: 'FILIAL_3',
    mercadorias: 'PVC',
    tipoCarga: 'Caminhão Baú',
    tipoProduto: 'Plásticos',
    conferente: 'Maria',
    ordemChegada: 4,
    horaOrdemChegada: '08:00',
    nf: 'NF-22222',
    dataProgramada: '2026-04-16T08:00:00Z',
    idSolicitacao: 'SOL-LMN456-OPQ',
    solicitante: 'Ana Costa',
    dataSolicitacao: '2026-04-13T11:00:00Z',
    statusSolicitacao: 'Finalizado',
    tipoProdutoSolicitacao: 'Plásticos',
    documentos: [{ nome: 'comprovante.pdf', url: '#' }],
    pedidos: [{ numero: 'PED-003', valor: 12000 }],
    observacoes: 'Entrega realizada com sucesso',
    ocorrencia: '',
    arquivoOcorrencia: null,
    prioridade: 1
  }
];

const Cargas: React.FC = () => {
  const { user } = useAuth();
  const { filialAtual } = useApp();
  const [cargas, setCargas] = useState<Carga[]>([]);
  const [conferentes, setConferentes] = useState<Conferente[]>([]);
  const [loading, setLoading] = useState(false);
  const [motivosOcorrencia, setMotivosOcorrencia] = useState<any[]>([]);
  // Inicializar data selecionada usando data atual do sistema
  const hoje = new Date();
  const [dataSelecionada, setDataSelecionada] = useState(
    new Date().toISOString().split('T')[0] // Formato YYYY-MM-DD
  );
  const [buscaCarga, setBuscaCarga] = useState('');
  const [agendamentosPorData, setAgendamentosPorData] = useState<Record<string, any[]>>({});
  const [agendamentosExpandidos, setAgendamentosExpandidos] = useState<Record<string, boolean>>({});
  const tableRef = useRef<HTMLTableElement>(null);

  const carregarMotivosOcorrencia = async () => {
    try {
      const motivos = await ConfiguracoesService.buscarMotivosOcorrencia();
      const motivosAtivos = motivos.filter(m => m.ativo);
      const nomesMotivos = Array.from(new Set(motivosAtivos.map(m => m.nome)));
      setMotivosOcorrencia(nomesMotivos);
    } catch (error) {
      console.error('Erro ao carregar motivos de ocorrência:', error);
      setMotivosOcorrencia([]);
    }
  };

  const carregarConferentes = async () => {
    try {
      const dados = await ConferentesService.buscarDisponiveisPorFilial(filialAtual || 'FILIAL_1');
      setConferentes(dados);
    } catch (error) {
      console.error('Erro ao carregar conferentes:', error);
      setConferentes([]);
    }
  };

  // Carregar cargas do Supabase
  useEffect(() => {
    carregarCargas();
    carregarMotivosOcorrencia();
    carregarConferentes();
  }, [filialAtual]);

  const carregarCargas = async () => {
    try {
      setLoading(true);
      const cargasData = await CargasService.buscarTodas(filialAtual || undefined);
      
      console.log('📦 Cargas carregadas do backend:', cargasData?.length, 'filial:', filialAtual);
      if (cargasData && cargasData.length > 0) {
        console.log('📦 Primeira carga:', JSON.stringify({ id: cargasData[0].id, data_programada: cargasData[0].data_programada, fornecedor: cargasData[0].fornecedor, status: cargasData[0].status }, null, 2));
      }
      
      // Mapear dados do Supabase para o formato esperado pelo componente
      const cargasMapeadas = cargasData.map((carga: any) => {
        const solicitacao = carga.solicitacoes_agendamento;
        // Parse tipo_carga and tipo_produto from observacoes METADATA for manual cargas
        let parsedTipoCarga = null;
        let parsedTipoProduto = null;
        let cleanObservacoes = carga.observacoes || solicitacao?.observacoes || 'Nenhuma observação';
        if (carga.observacoes && carga.observacoes.includes('METADATA:')) {
          const match = carga.observacoes.match(/METADATA:(\{.*\})/);
          if (match) {
            try {
              const meta = JSON.parse(match[1]);
              parsedTipoCarga = meta.tipo_carga || null;
              parsedTipoProduto = meta.tipo_produto || null;
              cleanObservacoes = carga.observacoes.replace(/\s*\|\s*METADATA:\{.*\}/, '').trim() || 'Nenhuma observação';
            } catch (e) { /* ignore parse error */ }
          }
        }
        return {
          id: carga.id,
          codigo: carga.codigo,
          fornecedor: carga.fornecedor || solicitacao?.fornecedor || 'Não informado',
          peso: carga.peso || solicitacao?.peso || 0,
          volume: carga.volume || solicitacao?.volume || 0,
          data: carga.data_programada || new Date().toISOString().split('T')[0],
          status: mapearStatus(carga.status),
          criadoEm: carga.created_at,
          criadoPor: user?.nome || 'Sistema',
          filial: carga.filial || solicitacao?.filial || 'FILIAL_1',
          mercadorias: solicitacao?.observacoes || cleanObservacoes || 'Não informado',
          tipoCarga: parsedTipoCarga || carga.tipo_carga || solicitacao?.tipo_carga || 'Não informado',
          tipoProduto: parsedTipoProduto || carga.tipo_produto || solicitacao?.tipo_produto || 'Não informado',
          conferente: carga.conferentes?.nome || solicitacao?.conferente || 'Não definido',
          ordemChegada: carga.ordem_chegada || solicitacao?.ordem_chegada || null,
          horaOrdemChegada: carga.hora_ordem_chegada || solicitacao?.hora_ordem_chegada || null,
          nf: 'Não informada',
          dataProgramada: carga.data_programada ? carga.data_programada.split('T')[0] : (carga.created_at ? carga.created_at.split('T')[0] : ''),
          idSolicitacao: carga.solicitacao_id || null,
          solicitante: solicitacao?.solicitante_id || null,
          dataSolicitacao: solicitacao?.data_desejada || null,
          statusSolicitacao: solicitacao?.status || null,
          tipoProdutoSolicitacao: solicitacao?.tipo_produto || null,
          documentos: solicitacao?.documentos || solicitacao?.arquivo_pedido || solicitacao?.documentos_digitados || [],
          pedidos: [],
          observacoes: cleanObservacoes,
          ocorrencia: carga.ocorrencia || '',
          arquivoOcorrencia: carga.arquivo_ocorrencia || null,
          prioridade: carga.prioridade || solicitacao?.prioridade || 3
        };
      });
      
      setCargas(cargasMapeadas);
      console.log('📦 Cargas mapeadas:', cargasMapeadas.length, 'dataSelecionada:', dataSelecionada);
      const doDia = cargasMapeadas.filter(c => c.dataProgramada === dataSelecionada);
      console.log('📦 Cargas do dia', dataSelecionada, ':', doDia.length, doDia.map(c => ({ fornecedor: c.fornecedor, dataProgramada: c.dataProgramada, status: c.status })));
    } catch (error) {
      console.error('Erro ao carregar cargas:', error);
      // Em caso de erro, usar dados mock
      setCargas(mockCargas);
    } finally {
      setLoading(false);
    }
  };

  const mapearStatus = (status: string): string => {
    switch (status) {
      case 'Pendente': return 'Não chegou';
      case 'Em Rota': return 'Chegou';
      case 'Entregue': return 'Finalizado';
      case 'Cancelado': return 'Cancelado';
      default: return status;
    }
  };

  // Controle de rolamento automático
  useEffect(() => {
    const table = tableRef.current;
    if (!table) return;

    let scrollInterval: NodeJS.Timeout | null = null;
    let isScrolling = false;

    const startAutoScroll = () => {
      if (scrollInterval) clearInterval(scrollInterval);
      scrollInterval = setInterval(() => {
        if (!isScrolling && table.scrollTop < table.scrollHeight - table.clientHeight - 100) {
          table.scrollTop += 2;
        }
      }, 50);
    };

    const stopAutoScroll = () => {
      if (scrollInterval) {
        clearInterval(scrollInterval);
        scrollInterval = null;
      }
      isScrolling = false;
    };

    const handleScroll = () => {
      isScrolling = true;
      stopAutoScroll();
      setTimeout(() => {
        isScrolling = false;
      }, 1000);
    };

    const handleMouseEnter = () => {
      if (table.scrollTop < table.scrollHeight - table.clientHeight - 100) {
        startAutoScroll();
      }
    };

    const handleMouseLeave = () => {
      stopAutoScroll();
    };

    table.addEventListener('scroll', handleScroll);
    table.addEventListener('mouseenter', handleMouseEnter);
    table.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      table.removeEventListener('scroll', handleScroll);
      table.removeEventListener('mouseenter', handleMouseEnter);
      table.removeEventListener('mouseleave', handleMouseLeave);
      if (scrollInterval) clearInterval(scrollInterval);
    };
  }, []);

  const [modalOrdemAberto, setModalOrdemAberto] = useState(false);
  const [cargaSelecionadaOrdem, setCargaSelecionadaOrdem] = useState<Carga | null>(null);
  const [modalStatusAberto, setModalStatusAberto] = useState(false);
  const [cargaSelecionadaStatus, setCargaSelecionadaStatus] = useState<Carga | null>(null);
  const [novoStatusSelecionado, setNovoStatusSelecionado] = useState('');
  const [modalOcorrenciasAberto, setModalOcorrenciasAberto] = useState(false);
  const [cargaSelecionadaOcorrencias, setCargaSelecionadaOcorrencias] = useState<Carga | null>(null);
  const [ocorrenciasSelecionadas, setOcorrenciasSelecionadas] = useState<string[]>([]);
  const [arquivoOcorrencia, setArquivoOcorrencia] = useState<File | null>(null);
  const [observacoesOcorrencia, setObservacoesOcorrencia] = useState('');
  const [enviarEmailFornecedor, setEnviarEmailFornecedor] = useState(false);
  const [mensagemEmail, setMensagemEmail] = useState('');
  const [modalPrioridadeAberto, setModalPrioridadeAberto] = useState(false);
  const [cargaSelecionadaPrioridade, setCargaSelecionadaPrioridade] = useState<Carga | null>(null);
  const [novaPrioridade, setNovaPrioridade] = useState(3);
  const [documentosSolicitacao, setDocumentosSolicitacao] = useState<Array<{ nome: string; url: string }>>([]);
  const [documentosPedido, setDocumentosPedido] = useState<Array<{ nome: string; url: string }>>([]);
  const [solicitacaoDetalhes, setSolicitacaoDetalhes] = useState<any>(null);
  const [pedidoDetalhes, setPedidoDetalhes] = useState<any>(null);
  const [modalConferenteAberto, setModalConferenteAberto] = useState(false);
  const [cargaSelecionadaConferente, setCargaSelecionadaConferente] = useState<Carga | null>(null);
  const [conferenteSelecionado, setConferenteSelecionado] = useState<string>('');
  const [modalDocumentosAberto, setModalDocumentosAberto] = useState(false);
  const [cargaSelecionadaDocumentos, setCargaSelecionadaDocumentos] = useState<Carga | null>(null);
  const [modalReagendar, setModalReagendar] = useState<{ aberto: boolean; carga: Carga | null }>({ aberto: false, carga: null });
  const [formReagendar, setFormReagendar] = useState({ novaData: '', motivo: '' });
  const [modalCargaManual, setModalCargaManual] = useState(false);
  const [formCargaManual, setFormCargaManual] = useState({
    fornecedor: '',
    produto: '',
    peso: '',
    volume: '',
    dataProgramada: '',
    tipoCarga: 'PALETIZADO',
    tipoProduto: 'SECOS',
    conferente: '',
    prioridade: 3,
    placa: '',
    motorista: '',
    observacoes: '',
    mercadorias: '',
    ocorrencias: [] as string[],
    status: 'Não chegou'
  });
  const [modalCargaRecorrente, setModalCargaRecorrente] = useState(false);
  const [formCargaRecorrente, setFormCargaRecorrente] = useState({
    fornecedor: '',
    produto: '',
    prioridade: 3,
    conferente: '',
    ocorrencias: [] as string[],
    observacaoOcorrencia: '',
    datasSelecionadas: [] as string[]
  });
  const [gruposRecorrentes, setGruposRecorrentes] = useState<any[]>([]);
  const [modalGrupoRecorrente, setModalGrupoRecorrente] = useState<{ aberto: boolean; grupo: any | null }>({ aberto: false, grupo: null });
  const [cargasGrupo, setCargasGrupo] = useState<any[]>([]);

  const abrirModalReagendar = (carga: Carga) => {
    setModalReagendar({ aberto: true, carga });
    setFormReagendar({ novaData: carga.dataProgramada || '', motivo: '' });
  };

  const fecharModalReagendar = () => {
    setModalReagendar({ aberto: false, carga: null });
  };

  const abrirModalCargaManual = () => {
    setModalCargaManual(true);
  };

  const fecharModalCargaManual = () => {
    setModalCargaManual(false);
    setFormCargaManual({
      fornecedor: '',
      produto: '',
      peso: '',
      volume: '',
      dataProgramada: '',
      tipoCarga: 'PALETIZADO',
      tipoProduto: 'SECOS',
      conferente: '',
      prioridade: 3,
      placa: '',
      motorista: '',
      observacoes: '',
      mercadorias: '',
      ocorrencias: [],
      status: 'Não chegou'
    });
  };

  const salvarCargaManual = async () => {
    if (!formCargaManual.fornecedor || !formCargaManual.dataProgramada) {
      alert('Preencha o fornecedor e a data desejada!');
      return;
    }

    try {
      const response = await apiRequest('/cargas', {
        method: 'POST',
        body: JSON.stringify({
          fornecedor: formCargaManual.fornecedor,
          peso: formCargaManual.peso ? parseFloat(formCargaManual.peso) : null,
          volume: formCargaManual.volume ? parseFloat(formCargaManual.volume) : null,
          tipo_carga: formCargaManual.tipoCarga,
          tipo_produto: formCargaManual.tipoProduto,
          conferente: formCargaManual.conferente || 'Não definido',
          prioridade: formCargaManual.prioridade,
          status: formCargaManual.status,
          observacoes: formCargaManual.mercadorias || null,
          ocorrencia: formCargaManual.ocorrencias.length > 0 ? formCargaManual.ocorrencias.join('; ') : null,
          filial: filialAtual || 'FILIAL_1',
          datas: [formCargaManual.dataProgramada]
        })
      });

      console.log('📦 Resposta da criação de carga:', JSON.stringify(response, null, 2));

      if (response.erros && response.erros.length > 0) {
        alert(`Erro ao criar carga: ${response.erros[0].erro}`);
        return;
      }

      if (!response.success && !response.data) {
        alert('Erro ao criar carga: resposta inválida do servidor');
        return;
      }

      fecharModalCargaManual();
      setDataSelecionada(formCargaManual.dataProgramada);
      await carregarCargas();
      console.log('✅ carregarCargas concluída após criação. dataSelecionada deveria ser:', formCargaManual.dataProgramada);
      alert('Carga criada com sucesso!');
    } catch (error) {
      console.error('Erro ao criar carga manual:', error);
      alert('Erro ao criar carga manual: ' + (error instanceof Error ? error.message : 'erro desconhecido'));
    }
  };

  const abrirModalCargaRecorrente = () => {
    setModalCargaRecorrente(true);
  };

  const carregarGruposRecorrentes = async () => {
    try {
      const response = await apiRequest('/cargas/grupos-recorrentes', { method: 'GET' });
      setGruposRecorrentes(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar grupos recorrentes:', error);
    }
  };

  const abrirModalGrupo = async (grupo: any) => {
    setModalGrupoRecorrente({ aberto: true, grupo });
    try {
      const response = await apiRequest(`/cargas/grupos-recorrentes/${grupo.id}`, { method: 'GET' });
      setCargasGrupo(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar cargas do grupo:', error);
    }
  };

  const fecharModalGrupo = () => {
    setModalGrupoRecorrente({ aberto: false, grupo: null });
    setCargasGrupo([]);
  };

  const excluirCargaIndividual = async (cargaId: string) => {
    if (!window.confirm('Tem certeza que deseja excluir esta carga?')) return;

    try {
      await apiRequest(`/cargas/grupos-recorrentes/${modalGrupoRecorrente.grupo.id}/cargas/${cargaId}`, {
        method: 'DELETE'
      });
      alert('Carga excluída com sucesso');
      // Recarregar cargas do grupo
      abrirModalGrupo(modalGrupoRecorrente.grupo);
      carregarCargas();
    } catch (error) {
      console.error('Erro ao excluir carga:', error);
      alert('Erro ao excluir carga');
    }
  };

  const excluirGrupoInteiro = async () => {
    if (!window.confirm('Tem certeza que deseja excluir TODAS as cargas deste grupo? Esta ação não pode ser desfeita.')) return;

    try {
      await apiRequest(`/cargas/grupos-recorrentes/${modalGrupoRecorrente.grupo.id}`, {
        method: 'DELETE'
      });
      alert('Grupo excluído com sucesso');
      fecharModalGrupo();
      carregarGruposRecorrentes();
      carregarCargas();
    } catch (error) {
      console.error('Erro ao excluir grupo:', error);
      alert('Erro ao excluir grupo');
    }
  };

  const excluirCarga = async (cargaId: string) => {
    if (!window.confirm('Tem certeza que deseja excluir esta carga?')) return;

    try {
      await apiRequest(`/cargas/${cargaId}`, {
        method: 'DELETE'
      });
      alert('Carga excluída com sucesso');
      carregarCargas();
      carregarGruposRecorrentes();
    } catch (error) {
      console.error('Erro ao excluir carga:', error);
      alert('Erro ao excluir carga');
    }
  };

  const fecharModalCargaRecorrente = () => {
    setModalCargaRecorrente(false);
    setFormCargaRecorrente({
      fornecedor: '',
      produto: '',
      prioridade: 3,
      conferente: '',
      ocorrencias: [],
      observacaoOcorrencia: '',
      datasSelecionadas: []
    });
  };

  const toggleDiaSemana = (dia: string) => {
    const dias = formCargaRecorrente.datasSelecionadas;
    if (dias.includes(dia)) {
      setFormCargaRecorrente({
        ...formCargaRecorrente,
        datasSelecionadas: dias.filter(d => d !== dia)
      });
    } else {
      setFormCargaRecorrente({
        ...formCargaRecorrente,
        datasSelecionadas: [...dias, dia]
      });
    }
  };

  const salvarCargaRecorrente = async () => {
    if (!formCargaRecorrente.fornecedor || formCargaRecorrente.datasSelecionadas.length === 0) {
      alert('Preencha o fornecedor e selecione pelo menos um dia!');
      return;
    }

    // Converter dias da semana em datas reais
    const diaParaNumero: Record<string, number> = {
      'Domingo': 0,
      'Segunda': 1,
      'Terça': 2,
      'Quarta': 3,
      'Quinta': 4,
      'Sexta': 5,
      'Sábado': 6
    };

    const datasCalculadas: string[] = [];
    const hoje = new Date();
    const diaAtual = hoje.getDay();

    // Para cada dia selecionado, calcular a próxima ocorrência
    formCargaRecorrente.datasSelecionadas.forEach((dia) => {
      const diaAlvo = diaParaNumero[dia];
      let diasParaAdicionar = diaAlvo - diaAtual;

      // Se o dia já passou esta semana, adicionar 7 dias para a próxima semana
      if (diasParaAdicionar <= 0) {
        diasParaAdicionar += 7;
      }

      const dataCalculada = new Date(hoje);
      dataCalculada.setDate(hoje.getDate() + diasParaAdicionar);
      datasCalculadas.push(dataCalculada.toISOString().split('T')[0]);
    });

    try {
      const ocorrenciaFormatada = formCargaRecorrente.ocorrencias.length > 0
        ? formCargaRecorrente.ocorrencias.join('; ') + (formCargaRecorrente.observacaoOcorrencia ? ' | Obs: ' + formCargaRecorrente.observacaoOcorrencia : '')
        : '';

      const response = await apiRequest('/cargas', {
        method: 'POST',
        body: JSON.stringify({
          fornecedor: formCargaRecorrente.fornecedor,
          produto: formCargaRecorrente.produto,
          prioridade: formCargaRecorrente.prioridade,
          conferente: formCargaRecorrente.conferente,
          ocorrencia: ocorrenciaFormatada,
          status: 'Não chegou',
          filial: filialAtual || 'FILIAL_1',
          datas: datasCalculadas
        })
      });

      if (response.erros && response.erros.length > 0) {
        alert(`Cargas criadas: ${response.total}. Erros: ${response.totalErros}`);
      } else {
        alert(`${response.total} cargas criadas com sucesso!`);
      }

      fecharModalCargaRecorrente();
      await carregarCargas();
      await carregarGruposRecorrentes();
    } catch (error) {
      console.error('Erro ao criar carga recorrente:', error);
      alert('Erro ao criar carga recorrente. Tente novamente.');
    }
  };

  const abrirModalDocumentos = (carga: Carga) => {
    setCargaSelecionadaDocumentos(carga);
    setModalDocumentosAberto(true);
  };

  const fecharModalDocumentos = () => {
    setModalDocumentosAberto(false);
    setCargaSelecionadaDocumentos(null);
  };

  const salvarReagendamento = async () => {
    if (!modalReagendar.carga || !formReagendar.novaData) {
      alert('Selecione a nova data!');
      return;
    }
    try {
      await apiRequest(`/cargas/${modalReagendar.carga.id}/reagendar`, {
        method: 'PATCH',
        body: JSON.stringify({ nova_data: formReagendar.novaData, motivo: formReagendar.motivo })
      });
      alert(`Carga reagendada para ${new Date(formReagendar.novaData + 'T12:00:00').toLocaleDateString('pt-BR')} com sucesso!`);
      fecharModalReagendar();
      await carregarCargas();
    } catch (error) {
      console.error('Erro ao reagendar carga:', error);
      alert('Erro ao reagendar carga. Tente novamente.');
    }
  };

  const buscarCargaPorFornecedor = async () => {
    if (!buscaCarga.trim()) {
      alert('Digite o nome do fornecedor para buscar');
      return;
    }

    try {
      const solicitacoes = await SolicitacoesService.buscarPorFornecedor(buscaCarga, filialAtual, false); // false para buscar todos, não apenas futuros
      
      // Filtrar para excluir solicitações reprovadas
      const solicitacoesFiltradas = solicitacoes.filter((solicitacao: any) => 
        solicitacao.status !== 'Reprovado' && solicitacao.status !== 'Reprovada'
      );
      
      // Agrupar por data
      const agrupados: Record<string, any[]> = {};
      solicitacoesFiltradas.forEach((solicitacao: any) => {
        const data = solicitacao.data_desejada ? solicitacao.data_desejada.split('T')[0] : 'Sem data';
        if (!agrupados[data]) {
          agrupados[data] = [];
        }
        agrupados[data].push(solicitacao);
      });

      setAgendamentosPorData(agrupados);
      
      if (solicitacoes.length === 0) {
        alert('Nenhum agendamento encontrado para este fornecedor');
      }
    } catch (error) {
      console.error('Erro ao buscar agendamentos:', error);
      alert('Erro ao buscar agendamentos');
    }
  };

  const abrirModalOrdemChegada = (carga: Carga) => {
    setCargaSelecionadaOrdem(carga);
    setModalOrdemAberto(true);
  };

  const fecharModalOrdemChegada = () => {
    setModalOrdemAberto(false);
    setCargaSelecionadaOrdem(null);
  };

  const salvarOrdemChegada = async (novaOrdem: number) => {
    if (!cargaSelecionadaOrdem) return;

    try {
      const horaAtual = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

      await CargasService.atualizar(cargaSelecionadaOrdem.id, {
        ordem_chegada: novaOrdem,
        hora_ordem_chegada: horaAtual
      });

      // Registrar no audit trail
      await AuditService.registrarAcao({
        usuarioId: user?.id || '',
        usuarioNome: user?.nome || '',
        acao: TipoAcaoAudit.ATUALIZAR,
        tabela: 'cargas',
        registroId: cargaSelecionadaOrdem.id,
        valoresAntigos: { ordem_chegada: cargaSelecionadaOrdem.ordemChegada, hora_ordem_chegada: cargaSelecionadaOrdem.horaOrdemChegada },
        valoresNovos: { ordem_chegada: novaOrdem, hora_ordem_chegada: horaAtual }
      });

      // Sincronizar ordem de chegada com a solicitação se existir
      if (cargaSelecionadaOrdem.idSolicitacao) {
        try {
          await SolicitacoesService.atualizarOrdemChegada(
            cargaSelecionadaOrdem.idSolicitacao,
            novaOrdem,
            horaAtual
          );

          // Registrar no audit trail da solicitação também
          await AuditService.registrarAcao({
            usuarioId: user?.id || '',
            usuarioNome: user?.nome || '',
            acao: TipoAcaoAudit.ATUALIZAR,
            tabela: 'solicitacoes_agendamento',
            registroId: cargaSelecionadaOrdem.idSolicitacao,
            valoresAntigos: { ordem_chegada: cargaSelecionadaOrdem.ordemChegada, hora_ordem_chegada: cargaSelecionadaOrdem.horaOrdemChegada },
            valoresNovos: { ordem_chegada: novaOrdem, hora_ordem_chegada: horaAtual }
          });

          // Buscar a solicitação para obter o solicitante_id correto
          const solicitacao = await SolicitacoesService.buscarPorId(cargaSelecionadaOrdem.idSolicitacao);
          if (solicitacao && solicitacao.solicitante_id) {
            await NotificacoesService.notificarCargaOrdemChegada(
              solicitacao.solicitante_id,
              cargaSelecionadaOrdem.id,
              cargaSelecionadaOrdem.idSolicitacao,
              novaOrdem,
              horaAtual
            );
          }
        } catch (syncError) {
          console.error('Erro ao sincronizar ordem de chegada:', syncError);
          // Não interrompe o fluxo principal
        }
      }

      // Recarregar cargas do banco
      await carregarCargas();

      fecharModalOrdemChegada();
    } catch (error) {
      console.error('❌ Erro ao atualizar ordem de chegada:', error);
      alert('Erro ao atualizar ordem de chegada!');
    }
  };

  const abrirModalStatus = (carga: Carga) => {
    setCargaSelecionadaStatus(carga);
    setNovoStatusSelecionado(carga.status);
    setModalStatusAberto(true);
  };

  const fecharModalStatus = () => {
    setModalStatusAberto(false);
    setCargaSelecionadaStatus(null);
    setNovoStatusSelecionado('');
  };

  const salvarStatus = async () => {
    if (!cargaSelecionadaStatus || !novoStatusSelecionado) return;

    try {
      const statusAnterior = cargaSelecionadaStatus.status;
      
      // Backend agora envia email automaticamente quando o status muda
      await CargasService.atualizarStatus(cargaSelecionadaStatus.id, novoStatusSelecionado as any);

      // Registrar no audit trail
      await AuditService.registrarAcao({
        usuarioId: user?.id || '',
        usuarioNome: user?.nome || '',
        acao: TipoAcaoAudit.ATUALIZAR,
        tabela: 'cargas',
        registroId: cargaSelecionadaStatus.id,
        valoresAntigos: { status: statusAnterior },
        valoresNovos: { status: novoStatusSelecionado }
      });

      // Criar notificação no sistema (sem email - backend já envia)
      if (cargaSelecionadaStatus.idSolicitacao) {
        try {
          const solicitacao = await SolicitacoesService.buscarPorId(cargaSelecionadaStatus.idSolicitacao);
          if (solicitacao && solicitacao.solicitante_id) {
            await NotificacoesService.criar({
              usuario_id: solicitacao.solicitante_id,
              tipo: TipoNotificacao.CARGA_STATUS_MUDADO,
              titulo: 'Status da Carga Atualizado',
              mensagem: `O status da carga foi alterado de "${statusAnterior}" para "${novoStatusSelecionado}".\n\nID da solicitação: ${cargaSelecionadaStatus.idSolicitacao}`,
              dados: { 
                cargaId: cargaSelecionadaStatus.id, 
                solicitacaoId: cargaSelecionadaStatus.idSolicitacao, 
                statusAnterior, 
                statusNovo: novoStatusSelecionado 
              }
            });
          }
        } catch (notificationError) {
          console.error('Erro ao criar notificação:', notificationError);
        }
      }

      // Sincronizar status com a solicitação se existir
      if (cargaSelecionadaStatus.idSolicitacao) {
        try {
          const statusMap: Record<string, string> = {
            'Chegou': 'Chegou',
            'Descarregando': 'Descarregando',
            'Finalizado': 'Finalizado'
          };

          const statusSolicitacao = statusMap[novoStatusSelecionado];

          if (statusSolicitacao) {
            await SolicitacoesService.atualizarStatus(
              cargaSelecionadaStatus.idSolicitacao,
              statusSolicitacao as any
            );
          }
        } catch (syncError) {
          console.error('Erro ao sincronizar status da solicitação:', syncError);
        }
      }

      await carregarCargas();
      fecharModalStatus();
    } catch (error) {
      console.error('Erro ao atualizar status da carga:', error);
      alert('Erro ao atualizar status da carga!');
    }
  };

  const abrirModalOcorrencias = async (carga: Carga) => {
    setCargaSelecionadaOcorrencias(carga);
    // Carregar ocorrências existentes
    const ocorrenciasExistentes = carga.ocorrencia 
      ? carga.ocorrencia.split(';').map(o => o.trim()).filter(Boolean)
      : [];
    setOcorrenciasSelecionadas(ocorrenciasExistentes);
    setArquivoOcorrencia(null);
    setEnviarEmailFornecedor(false);
    setMensagemEmail('');
    // Recarregar motivos de ocorrência para garantir dados atualizados
    await carregarMotivosOcorrencia();
    setModalOcorrenciasAberto(true);
  };

  const fecharModalOcorrencias = () => {
    setModalOcorrenciasAberto(false);
    setCargaSelecionadaOcorrencias(null);
    setOcorrenciasSelecionadas([]);
    setArquivoOcorrencia(null);
    setObservacoesOcorrencia('');
    setEnviarEmailFornecedor(false);
    setMensagemEmail('');
  };

  const salvarOcorrencias = async () => {
    if (!cargaSelecionadaOcorrencias) return;

    try {
      // Criar string simples com motivos e observações
      let descricaoOcorrencia = ocorrenciasSelecionadas.join('; ');
      
      // Adicionar observações se existirem
      if (observacoesOcorrencia && observacoesOcorrencia.trim()) {
        descricaoOcorrencia += ` | Obs: ${observacoesOcorrencia}`;
      }
      
      // Função para limpar descrição para notificação (remover JSON)
      const limparDescricaoParaNotificacao = (descricao: string): string => {
        try {
          // Tentar parsear como JSON
          let valorLimpo = descricao.trim();
          
          // Se tiver ponto e vírgula, pegar apenas a parte antes
          if (valorLimpo.includes(';')) {
            valorLimpo = valorLimpo.split(';')[0].trim();
          }
          
          const parseado = JSON.parse(valorLimpo);
          if (Array.isArray(parseado) && parseado.length > 0) {
            // Extrair apenas os motivos
            return parseado.map(o => o.motivo).join('; ');
          } else if (parseado.motivo) {
            return parseado.motivo;
          }
        } catch {
          // Não é JSON, retornar como está
          return descricao;
        }
        return descricao;
      };
      
      const descricaoLimpa = limparDescricaoParaNotificacao(descricaoOcorrencia);
      
      // Upload do arquivo se existir
      let arquivoUrl: string | undefined;
      if (arquivoOcorrencia) {
        try {
          const uploadResult = await DocumentosService.uploadArquivoOcorrencia(
            arquivoOcorrencia,
            cargaSelecionadaOcorrencias.id
          );
          arquivoUrl = uploadResult.url;
        } catch (error) {
          console.error('❌ Erro ao fazer upload do arquivo:', error);
          alert('Erro ao fazer upload do arquivo. As ocorrências serão salvas sem o arquivo.');
        }
      }
      
      // Salvar no banco de dados
      await CargasService.atualizar(cargaSelecionadaOcorrencias.id, {
        ocorrencia: descricaoOcorrencia,
        arquivo_ocorrencia: arquivoUrl || undefined
      });

      // Registrar no audit trail
      await AuditService.registrarAcao({
        usuarioId: user?.id || '',
        usuarioNome: user?.nome || '',
        acao: TipoAcaoAudit.ATUALIZAR,
        tabela: 'cargas',
        registroId: cargaSelecionadaOcorrencias.id,
        valoresAntigos: { ocorrencia: cargaSelecionadaOcorrencias.ocorrencia },
        valoresNovos: { ocorrencia: descricaoOcorrencia },
        motivo: mensagemEmail || 'Ocorrências registradas'
      });

      // Enviar notificação ao solicitante
      if (cargaSelecionadaOcorrencias.idSolicitacao) {
        const solicitacao = await SolicitacoesService.buscarPorId(cargaSelecionadaOcorrencias.idSolicitacao);
        if (solicitacao && solicitacao.solicitante_id) {
          await NotificacoesService.notificarCargaOcorrencia(
            solicitacao.solicitante_id,
            cargaSelecionadaOcorrencias.id,
            cargaSelecionadaOcorrencias.idSolicitacao,
            descricaoLimpa
          );
        }
      }

      // Recarregar cargas do banco
      await carregarCargas();

      // Se marcado para enviar email, enviar via API
      if (enviarEmailFornecedor) {
        try {
          await apiRequest('/email-ocorrencia/enviar', {
            method: 'POST',
            body: JSON.stringify({
              fornecedor: cargaSelecionadaOcorrencias.fornecedor,
              cargasId: cargaSelecionadaOcorrencias.id,
              ocorrencias: ocorrenciasSelecionadas,
              arquivoUrl: arquivoUrl,
              mensagem: mensagemEmail
            })
          });
          alert(`Email enviado para ${cargaSelecionadaOcorrencias.fornecedor} com as ocorrências registradas!`);
        } catch (error) {
          console.error('❌ Erro ao enviar email:', error);
          alert('Erro ao enviar email para o fornecedor. As ocorrências foram salvas.');
        }
      }

      fecharModalOcorrencias();
      alert('Ocorrências salvas com sucesso!');
    } catch (error) {
      console.error('Erro ao salvar ocorrências:', error);
      alert('Erro ao salvar ocorrências!');
    }
  };

  const abrirModalPrioridade = (carga: Carga) => {
    setCargaSelecionadaPrioridade(carga);
    setNovaPrioridade(carga.prioridade);
    setModalPrioridadeAberto(true);
  };

  const fecharModalPrioridade = () => {
    setModalPrioridadeAberto(false);
    setCargaSelecionadaPrioridade(null);
    setNovaPrioridade(3);
  };

  const salvarPrioridade = async () => {
    if (!cargaSelecionadaPrioridade) return;

    try {
      const prioridadeAnterior = cargaSelecionadaPrioridade.prioridade;
      await CargasService.atualizar(cargaSelecionadaPrioridade.id, {
        prioridade: novaPrioridade
      });

      // Enviar notificação ao solicitante
      if (cargaSelecionadaPrioridade.idSolicitacao) {
        const solicitacao = await SolicitacoesService.buscarPorId(cargaSelecionadaPrioridade.idSolicitacao);
        if (solicitacao && solicitacao.solicitante_id) {
          await NotificacoesService.notificarCargaPrioridadeMudada(
            solicitacao.solicitante_id,
            cargaSelecionadaPrioridade.id,
            cargaSelecionadaPrioridade.idSolicitacao,
            prioridadeAnterior,
            novaPrioridade
          );
        }
      }

      // Recarregar cargas do banco
      await carregarCargas();

      fecharModalPrioridade();
    } catch (error) {
      console.error('Erro ao atualizar prioridade:', error);
      alert('Erro ao atualizar prioridade!');
    }
  };

  const abrirModalConferente = async (carga: Carga) => {
    setCargaSelecionadaConferente(carga);
    setConferenteSelecionado(carga.conferente || '');
    // Recarregar conferentes ao abrir modal
    await carregarConferentes();
    setModalConferenteAberto(true);
  };

  const fecharModalConferente = () => {
    setModalConferenteAberto(false);
    setCargaSelecionadaConferente(null);
    setConferenteSelecionado('');
  };

  const salvarConferente = async () => {
    if (!cargaSelecionadaConferente) return;

    try {
      const conferenteAnterior = cargaSelecionadaConferente.conferente;
      
      // Atualizar a solicitação com o conferente selecionado usando apiRequest direto
      if (cargaSelecionadaConferente.idSolicitacao) {
        await apiRequest(`/solicitacoes-agendamento/${cargaSelecionadaConferente.idSolicitacao}/conferente`, {
          method: 'PATCH',
          body: JSON.stringify({ conferente: conferenteSelecionado })
        });
      }

      // Registrar no audit trail
      await AuditService.registrarAcao({
        usuarioId: user?.id || '',
        usuarioNome: user?.nome || '',
        acao: TipoAcaoAudit.ATUALIZAR,
        tabela: 'solicitacoes_agendamento',
        registroId: cargaSelecionadaConferente.idSolicitacao || '',
        valoresAntigos: { conferente: conferenteAnterior },
        valoresNovos: { conferente: conferenteSelecionado }
      });

      await carregarCargas();
      fecharModalConferente();
    } catch (error) {
      console.error('Erro ao atualizar conferente:', error);
      alert('Erro ao atualizar conferente!');
    }
  };

  const toggleOcorrencia = (ocorrencia: string) => {
    setOcorrenciasSelecionadas(prev => {
      if (prev.includes(ocorrencia)) {
        return prev.filter(o => o !== ocorrencia);
      } else {
        return [...prev, ocorrencia];
      }
    });
  };

  const formatarDataHora = (dataString: string | null) => {
    if (!dataString) return 'Não informada';
    const data = new Date(dataString);
    return data.toLocaleString('pt-BR');
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Finalizado': return 'bg-green-100 text-green-800';
      case 'Descarregando': return 'bg-blue-100 text-blue-800';
      case 'Pronta': return 'bg-purple-100 text-purple-800';
      case 'Chegou': return 'bg-yellow-100 text-yellow-800';
      case 'Não chegou': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getPrioridade = (status: string) => {
    const prioridadeStatus: Record<string, string> = {
      'Descarregando': 'ALTA',
      'Chegou': 'ALTA',
      'Pronta': 'MÉDIA',
      'Não chegou': 'BAIXA',
      'Finalizado': 'BAIXA'
    };
    return prioridadeStatus[status] || 'BAIXA';
  };

  const getPrioridadeColor = (prioridade: number) => {
    switch (prioridade) {
      case 5: return 'bg-red-500 text-white';
      case 4: return 'bg-orange-500 text-white';
      case 3: return 'bg-yellow-500 text-white';
      case 2: return 'bg-green-500 text-white';
      case 1: return 'bg-green-600 text-white';
      default: return 'bg-gray-500 text-white';
    }
  };

  // Calcular estatísticas do dia
  const [ano, mes, dia] = dataSelecionada.split('-').map(Number);
  const dataAtual = new Date(ano, mes - 1, dia).toLocaleDateString('pt-BR');
  const cargasDoDiaFiltradas = cargas.filter(c => c.dataProgramada === dataSelecionada);
  const cargasDoDia = cargasDoDiaFiltradas.length;
  const pesoTotal = cargasDoDiaFiltradas.reduce((acc, c) => acc + c.peso, 0);
  const finalizadas = cargasDoDiaFiltradas.filter(c => c.status === 'Finalizado').length;
  const eficiencia = finalizadas > 0 ? ((finalizadas / cargasDoDia) * 100).toFixed(1) : '0.0';
  const ocorrências = cargasDoDiaFiltradas.reduce((acc, c) => {
    if (c.ocorrencia && c.ocorrencia.trim() !== '') {
      return acc + c.ocorrencia.split(';').filter(o => o.trim() !== '').length;
    }
    return acc;
  }, 0);
  const cargasFrios = cargasDoDiaFiltradas.filter(c => c.tipoProduto === 'CONGELADOS' || c.tipoProduto === 'REFRIGERADOS').length;
  const cargasSecos = cargasDoDiaFiltradas.filter(c => c.tipoProduto === 'SECOS').length;

  // Ordenar cargas por prioridade, ordem de chegada e status (apenas da data selecionada)
  const cargasOrdenadas = [...cargasDoDiaFiltradas].sort((a, b) => {
    // Primeiro, ordenar por prioridade (maior prioridade primeiro)
    if (a.prioridade !== b.prioridade) {
      return b.prioridade - a.prioridade;
    }
    // Depois, ordenar por ordem de chegada
    if (a.ordemChegada && b.ordemChegada) {
      return a.ordemChegada - b.ordemChegada;
    }
    // Por fim, ordenar por status
    const prioridadeStatus: Record<string, number> = {
      'Descarregando': 1,
      'Chegou': 2,
      'Pronta': 3,
      'Não chegou': 4,
      'Finalizado': 5
    };
    const prioridadeA = prioridadeStatus[a.status] || 99;
    const prioridadeB = prioridadeStatus[b.status] || 99;
    return prioridadeA - prioridadeB;
  });

  // Top conferentes
  const conferentesCount: Record<string, number> = {};
  cargas.forEach(c => {
    if (c.conferente && c.conferente !== 'Não definido' && c.conferente !== '-') {
      conferentesCount[c.conferente] = (conferentesCount[c.conferente] || 0) + 1;
    }
  });
  const topConferentes = Object.entries(conferentesCount)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 3)
    .map(([nome, count]) => ({ nome, count }));

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Cargas</h1>

        {/* Estatísticas do Dia */}
        <div className="bg-white p-6 rounded-lg shadow mb-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-semibold">📊 Cargas do Dia</h2>
            <div className="flex items-center gap-3">
              <DatePicker
                value={dataSelecionada}
                onChange={(date) => {
                  if (date) {
                    // Criar data local para evitar problemas de fuso horário
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    setDataSelecionada(`${year}-${month}-${day}`);
                  } else {
                    setDataSelecionada('');
                  }
                }}
              />
              <span className="text-sm text-gray-500">{dataAtual}</span>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-4">
            <div className="bg-blue-50 p-4 rounded-lg">
              <div className="text-sm font-medium text-blue-700">📊 Cargas do Dia</div>
              <div className="text-3xl font-bold text-blue-900">{cargasDoDia}</div>
            </div>

            <div className="bg-purple-50 p-4 rounded-lg">
              <div className="text-sm font-medium text-purple-700">✅ Finalizadas</div>
              <div className="text-3xl font-bold text-purple-900">{finalizadas}</div>
            </div>

            <div className="bg-red-50 p-4 rounded-lg">
              <div className="text-sm font-medium text-red-700">⚠️ Ocorrências</div>
              <div className="text-3xl font-bold text-red-900">{ocorrências}</div>
            </div>

            <div className="bg-cyan-50 p-4 rounded-lg">
              <div className="text-sm font-medium text-cyan-700">❄️ Cargas Refrigeradas/Congeladas</div>
              <div className="text-3xl font-bold text-cyan-900">{cargasFrios}</div>
            </div>

            <div className="bg-orange-50 p-4 rounded-lg">
              <div className="text-sm font-medium text-orange-700">📦 Cargas de Secos</div>
              <div className="text-3xl font-bold text-orange-900">{cargasSecos}</div>
            </div>
          </div>
        </div>

        {/* Tabela de cargas */}
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full" ref={tableRef}>
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ordem</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Prioridade</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fornecedor</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Conferente</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mercadorias</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo Carga</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo Produto</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Documentos</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ocorrências</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {cargasOrdenadas.map((carga) => (
                  <tr key={carga.id} className="hover:bg-gray-50">
                    <td className="px-4 py-4 whitespace-nowrap cursor-pointer hover:bg-gray-50" onClick={() => abrirModalStatus(carga)}>
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(carga.status)}`}>
                        {carga.status}
                      </span>
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-center cursor-pointer hover:bg-gray-50" onClick={() => abrirModalOrdemChegada(carga)}>
                      {carga.ordemChegada && carga.horaOrdemChegada ? (
                        <div className="flex flex-col items-center gap-1">
                          <span className="font-bold text-lg text-blue-600">{carga.ordemChegada}°</span>
                          <span className="text-xs text-gray-500">{carga.horaOrdemChegada}</span>
                        </div>
                      ) : carga.ordemChegada ? (
                        <span className="font-bold text-lg text-blue-600">{carga.ordemChegada}°</span>
                      ) : (
                        <span className="text-gray-400">-</span>
                      )}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap cursor-pointer hover:bg-gray-50" onClick={() => abrirModalPrioridade(carga)}>
                      <span className={`inline-flex px-2 py-1 text-xs font-bold rounded ${getPrioridadeColor(carga.prioridade)}`}>
                        {carga.prioridade}
                      </span>
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">{carga.fornecedor}</td>
                    <td className="px-4 py-4 whitespace-nowrap cursor-pointer hover:bg-gray-50" onClick={() => abrirModalConferente(carga)}>
                      <span className="text-sm text-gray-900">{carga.conferente}</span>
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">{carga.mercadorias}</td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">{carga.tipoCarga}</td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">{carga.tipoProduto}</td>
                    <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                      {carga.documentos && carga.documentos.length > 0 ? (
                        <button
                          onClick={() => abrirModalDocumentos(carga)}
                          className="text-blue-600 hover:text-blue-800 font-medium"
                        >
                          📄 {carga.documentos.length}
                        </button>
                      ) : (
                        <span className="text-gray-400">-</span>
                      )}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap cursor-pointer hover:bg-gray-50" onClick={() => abrirModalOcorrencias(carga)}>
                      {carga.ocorrencia ? (
                        <div className="flex items-center gap-2">
                          <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">
                            {(() => {
                              try {
                                // Limpar o valor - remover texto extra após o JSON
                                let valorLimpo = carga.ocorrencia.trim();
                                
                                // Se tiver ponto e vírgula, pegar apenas a parte antes
                                if (valorLimpo.includes(';')) {
                                  valorLimpo = valorLimpo.split(';')[0].trim();
                                }
                                
                                // Tentar parsear como JSON (formato antigo)
                                const parseado = JSON.parse(valorLimpo);
                                if (Array.isArray(parseado) && parseado.length > 0) {
                                  // Formato antigo: array de objetos
                                  const motivo = parseado[0]?.motivo || 'Ocorrência';
                                  const quantidade = parseado.length > 1 ? ` +${parseado.length - 1}` : '';
                                  return motivo + quantidade;
                                } else if (parseado.motivo) {
                                  // Objeto único
                                  return parseado.motivo;
                                }
                              } catch {
                                // String simples: "Motivo1; Motivo2 | Obs: observação"
                                const partes = carga.ocorrencia.split(' | Obs: ');
                                const motivos = partes[0].split(';');
                                const motivoPrincipal = motivos[0].trim();
                                const quantidade = motivos.length > 1 ? ` +${motivos.length - 1}` : '';
                                return motivoPrincipal + quantidade;
                              }
                              return 'Ocorrência';
                            })()}
                          </span>
                          {carga.arquivoOcorrencia && (
                            <span className="text-blue-600" title="Arquivo anexado">📎</span>
                          )}
                        </div>
                      ) : (
                        <span className="text-gray-400 text-xs">Nenhuma</span>
                      )}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap">
                      <div className="flex gap-2">
                        <button
                          onClick={() => abrirModalReagendar(carga)}
                          className="flex items-center gap-1 bg-indigo-600 hover:bg-indigo-700 text-white text-xs px-3 py-1.5 rounded-md font-medium transition-colors"
                          title="Reagendar carga"
                        >
                          📅 Reagendar
                        </button>
                        <button
                          onClick={() => excluirCarga(carga.id)}
                          className="flex items-center gap-1 bg-red-600 hover:bg-red-700 text-white text-xs px-3 py-1.5 rounded-md font-medium transition-colors"
                          title="Excluir carga"
                        >
                          🗑️ Excluir
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {cargasOrdenadas.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-500">Nenhuma carga encontrada</p>
            </div>
          )}
        </div>

        {/* Campo de busca "Consultar Carga" */}
        <div className="mt-6 bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold">Consultar Carga</h3>
            <div className="flex gap-2">
              <button
                onClick={abrirModalCargaManual}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md font-medium transition-colors"
              >
                + Nova Carga
              </button>
              <button
                onClick={abrirModalCargaRecorrente}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md font-medium transition-colors"
              >
                + Nova Carga Recorrente
              </button>
            </div>
          </div>
          <div className="flex gap-4">
            <Input
              label="Nome do Fornecedor"
              value={buscaCarga}
              onChange={setBuscaCarga}
              placeholder="Digite o nome do fornecedor para buscar"
              className="flex-1"
            />
            <Button onClick={buscarCargaPorFornecedor} className="self-end">🔍 Buscar</Button>
          </div>
        </div>
      </div>

      {/* Resultado da Busca - Agendamentos agrupados por data */}
      {Object.keys(agendamentosPorData).length > 0 && (
        <div className="mt-6 bg-white p-6 rounded-lg shadow">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold">� Próximos Agendamentos - {buscaCarga}</h3>
            <Button onClick={() => { setAgendamentosPorData({}); setBuscaCarga(''); }} variant="secondary" size="sm">✕ Fechar</Button>
          </div>

          <div className="space-y-4">
            {Object.entries(agendamentosPorData).sort(([a], [b]) => a.localeCompare(b)).map(([data, agendamentos]) => (
              <div key={data} className="border rounded-lg overflow-hidden">
                <div 
                  className="bg-blue-50 p-4 cursor-pointer flex justify-between items-center hover:bg-blue-100 transition-colors"
                  onClick={() => setAgendamentosExpandidos(prev => ({ ...prev, [data]: !prev[data] }))}
                >
                  <div className="flex items-center gap-3">
                    <span className="text-2xl">📆</span>
                    <span className="font-semibold text-blue-900">
                      {formatarDataHora(data)}
                    </span>
                    <span className="bg-blue-200 text-blue-800 text-xs px-2 py-1 rounded-full">
                      {agendamentos.length} agendamento{agendamentos.length !== 1 ? 's' : ''}
                    </span>
                  </div>
                  <span className="text-blue-600">
                    {agendamentosExpandidos[data] ? '▼' : '▶'}
                  </span>
                </div>

                {agendamentosExpandidos[data] && (
                  <div className="p-4 space-y-3">
                    {agendamentos.map((agendamento: any) => (
                      <div key={agendamento.id} className="bg-gray-50 p-4 rounded-lg border-l-4 border-blue-500">
                        <div className="flex justify-between items-start mb-2">
                          <div className="flex-1">
                            <div className="flex items-center gap-2 mb-2">
                              <span className="text-sm font-semibold text-gray-700">{agendamento.codigo || 'SOL-' + agendamento.id.substring(0, 8)}</span>
                              <span className={`text-xs px-2 py-1 rounded-full ${
                                agendamento.status === 'APROVADO' ? 'bg-green-100 text-green-800' :
                                agendamento.status === 'PENDENTE' ? 'bg-yellow-100 text-yellow-800' :
                                agendamento.status === 'REPROVADO' ? 'bg-red-100 text-red-800' :
                                'bg-gray-100 text-gray-800'
                              }`}>
                                {agendamento.status || 'PENDENTE'}
                              </span>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 text-sm">
                              <div><strong>Fornecedor:</strong> {agendamento.fornecedor}</div>
                              <div><strong>Produto:</strong> {agendamento.mercadoria_descricao || agendamento.fornecedor_mercadoria || 'Não informado'}</div>
                              <div><strong>Tipo:</strong> {agendamento.tipo_produto || '-'}</div>
                              <div><strong>Peso:</strong> {agendamento.peso ? `${agendamento.peso} kg` : '-'}</div>
                              <div><strong>Volume:</strong> {agendamento.volume ? `${agendamento.volume} m³` : '-'}</div>
                              <div><strong>Hora:</strong> {agendamento.data_desejada ? agendamento.data_desejada.split('T')[1]?.substring(0, 5) : '-'}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Modal de Ordem de Chegada */}
      <Modal
        isOpen={modalOrdemAberto}
        onClose={fecharModalOrdemChegada}
        title="🏁 Selecionar Ordem de Chegada"
        size="sm"
      >
        <div className="space-y-4">
          <p className="text-sm text-gray-600">
            {cargaSelecionadaOrdem?.ordemChegada
              ? `Alterar ordem de chegada (atual: <strong>${cargaSelecionadaOrdem.ordemChegada}°</strong>):`
              : 'Selecione a ordem de chegada para esta carga:'}
          </p>
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2 max-h-60 overflow-y-auto">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map((ordem) => (
              <Button
                key={ordem}
                onClick={() => salvarOrdemChegada(ordem)}
                variant={cargaSelecionadaOrdem?.ordemChegada === ordem ? 'primary' : 'secondary'}
                size="sm"
              >
                {ordem}°
              </Button>
            ))}
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <Button onClick={fecharModalOrdemChegada} variant="secondary">
              Cancelar
            </Button>
          </div>
        </div>
      </Modal>

      {/* Modal de Prioridade */}
      <Modal
        isOpen={modalPrioridadeAberto}
        onClose={fecharModalPrioridade}
        title="⭐ Alterar Prioridade"
        size="sm"
      >
        <div className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-blue-500">
            <p className="text-sm"><strong>Carga:</strong> {cargaSelecionadaPrioridade?.codigo}</p>
            <p className="text-sm"><strong>Fornecedor:</strong> {cargaSelecionadaPrioridade?.fornecedor}</p>
            <p className="text-sm"><strong>Prioridade Atual:</strong> <span className={`inline-flex px-2 py-1 text-xs font-bold rounded ${getPrioridadeColor(cargaSelecionadaPrioridade?.prioridade || 3)}`}>{cargaSelecionadaPrioridade?.prioridade}</span></p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Selecione a nova prioridade:</label>
            <div className="grid grid-cols-5 gap-2">
              {[1, 2, 3, 4, 5].map((prioridade) => (
                <Button
                  key={prioridade}
                  onClick={() => setNovaPrioridade(prioridade)}
                  variant={novaPrioridade === prioridade ? 'primary' : 'secondary'}
                  size="sm"
                  className={`flex flex-col items-center gap-1`}
                >
                  <span className="text-lg">⭐</span>
                  <span className="text-xs">{prioridade}</span>
                  <span className="text-xs opacity-75">
                    {prioridade === 1 ? 'Baixa' :
                     prioridade === 2 ? 'Média-Baixa' :
                     prioridade === 3 ? 'Média' :
                     prioridade === 4 ? 'Alta' : 'Urgente'}
                  </span>
                </Button>
              ))}
            </div>
            <div className="mt-3 text-xs text-gray-500">
              <p>1 - Baixa (Verde)</p>
              <p>2 - Média-Baixa (Verde)</p>
              <p>3 - Média (Amarelo)</p>
              <p>4 - Alta (Laranja)</p>
              <p>5 - Urgente (Vermelho)</p>
            </div>
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <Button onClick={fecharModalPrioridade} variant="secondary">
              Cancelar
            </Button>
            <Button onClick={salvarPrioridade} variant="primary">
              Salvar
            </Button>
          </div>
        </div>
      </Modal>

      {/* Modal de Alteração de Status */}
      <Modal
        isOpen={modalStatusAberto}
        onClose={fecharModalStatus}
        title="🔄 Confirmar Alteração de Status"
        size="sm"
      >
        <div className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-yellow-500">
            <p className="text-sm"><strong>Carga:</strong> {cargaSelecionadaStatus?.codigo}</p>
            <p className="text-sm"><strong>Status Atual:</strong> {cargaSelecionadaStatus?.status}</p>
            <p className="text-sm"><strong>Novo Status:</strong> <span className="font-semibold text-blue-600">{novoStatusSelecionado}</span></p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Selecione o novo status:</label>
            <select
              value={novoStatusSelecionado}
              onChange={(e) => setNovoStatusSelecionado(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="Não chegou">🚫 Não chegou</option>
              <option value="Chegou">📍 Chegou</option>
              <option value="Pronta">⏳ Pronta</option>
              <option value="Descarregando">📦 Descarregando</option>
              <option value="Finalizado">✨ Finalizado</option>
              <option value="Cancelado">❌ Cancelado</option>
            </select>
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <Button onClick={fecharModalStatus} variant="secondary">
              Cancelar
            </Button>
            <Button onClick={salvarStatus} variant="primary">
              Confirmar
            </Button>
          </div>
        </div>
      </Modal>

      {/* Modal de Ocorrências */}
      <Modal
        isOpen={modalOcorrenciasAberto}
        onClose={fecharModalOcorrencias}
        title="⚠️ Ocorrências da Carga"
        size="lg"
      >
        <div className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-red-500">
            <p className="text-sm"><strong>Carga:</strong> {cargaSelecionadaOcorrencias?.codigo}</p>
            <p className="text-sm"><strong>Fornecedor:</strong> {cargaSelecionadaOcorrencias?.fornecedor}</p>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Selecione as ocorrências:</label>
            <div className="grid grid-cols-2 gap-2">
              {motivosOcorrencia.map((oc, idx) => (
                <label key={idx} className="flex items-center gap-2 p-2 bg-gray-50 rounded hover:bg-gray-100 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={ocorrenciasSelecionadas.includes(oc)}
                    onChange={() => toggleOcorrencia(oc)}
                    className="rounded border-gray-300 text-red-600 focus:ring-red-500"
                  />
                  <span className="text-sm">{oc}</span>
                </label>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Observações:</label>
            <textarea
              value={observacoesOcorrencia}
              onChange={(e) => setObservacoesOcorrencia(e.target.value)}
              placeholder="Digite observações adicionais sobre as ocorrências..."
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Anexar arquivo da ocorrência (opcional):</label>
            <input
              type="file"
              onChange={(e) => setArquivoOcorrencia(e.target.files?.[0] || null)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              accept=".pdf,.jpg,.jpeg,.png"
            />
            {arquivoOcorrencia && (
              <p className="text-sm text-green-600 mt-1">Arquivo selecionado: {arquivoOcorrencia.name}</p>
            )}
          </div>

          <div className="border-t pt-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={enviarEmailFornecedor}
                onChange={(e) => setEnviarEmailFornecedor(e.target.checked)}
                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <span className="text-sm font-medium text-gray-700">📧 Enviar notificação por email ao fornecedor</span>
            </label>
            
            {enviarEmailFornecedor && (
              <div className="mt-3">
                <label className="block text-sm font-medium text-gray-700 mb-2">Mensagem adicional (opcional):</label>
                <textarea
                  value={mensagemEmail}
                  onChange={(e) => setMensagemEmail(e.target.value)}
                  placeholder="Adicione uma mensagem adicional para o fornecedor..."
                  rows={3}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            )}
          </div>

          <div className="flex justify-between items-center mt-4">
            <Button onClick={() => { setOcorrenciasSelecionadas([]); }} variant="secondary" size="sm">
              Limpar seleção
            </Button>
            <div className="flex gap-2">
              <Button onClick={fecharModalOcorrencias} variant="secondary">
                Cancelar
              </Button>
              <Button onClick={salvarOcorrencias} variant="primary">
                Salvar Ocorrências
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Modal de Reagendamento */}
      <Modal
        isOpen={modalReagendar.aberto}
        onClose={fecharModalReagendar}
        title="📅 Reagendar Carga"
        size="sm"
      >
        <div className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-indigo-500">
            <p className="text-sm"><strong>Carga:</strong> {modalReagendar.carga?.codigo}</p>
            <p className="text-sm"><strong>Fornecedor:</strong> {modalReagendar.carga?.fornecedor}</p>
            <p className="text-sm"><strong>Data Atual:</strong> {modalReagendar.carga?.dataProgramada ? new Date(modalReagendar.carga.dataProgramada + 'T12:00:00').toLocaleDateString('pt-BR') : '-'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nova data:</label>
            <input
              type="date"
              value={formReagendar.novaData}
              onChange={(e) => setFormReagendar(f => ({ ...f, novaData: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Motivo <span className="text-gray-400">(opcional)</span>:</label>
            <textarea
              value={formReagendar.motivo}
              onChange={(e) => setFormReagendar(f => ({ ...f, motivo: e.target.value }))}
              placeholder="Ex: Fornecedor não compareceu, chegou antecipado..."
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <Button onClick={fecharModalReagendar} variant="secondary">Cancelar</Button>
            <Button onClick={salvarReagendamento} variant="primary">Confirmar Reagendamento</Button>
          </div>
        </div>
      </Modal>

      {/* Modal de Carga Recorrente */}
      <Modal
        isOpen={modalCargaRecorrente}
        onClose={fecharModalCargaRecorrente}
        title="📅 Nova Carga Recorrente"
        size="lg"
      >
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Fornecedor *</label>
            <input
              type="text"
              value={formCargaRecorrente.fornecedor}
              onChange={(e) => setFormCargaRecorrente(f => ({ ...f, fornecedor: e.target.value }))}
              placeholder="Nome do fornecedor"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Produto</label>
            <input
              type="text"
              value={formCargaRecorrente.produto}
              onChange={(e) => setFormCargaRecorrente(f => ({ ...f, produto: e.target.value }))}
              placeholder="Descrição do produto"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Prioridade</label>
            <select
              value={formCargaRecorrente.prioridade}
              onChange={(e) => setFormCargaRecorrente(f => ({ ...f, prioridade: parseInt(e.target.value) }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="1">1 - Alta</option>
              <option value="2">2 - Média Alta</option>
              <option value="3">3 - Média</option>
              <option value="4">4 - Média Baixa</option>
              <option value="5">5 - Baixa</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Conferente</label>
            <select
              value={formCargaRecorrente.conferente}
              onChange={(e) => setFormCargaRecorrente(f => ({ ...f, conferente: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="">Não definido</option>
              {conferentes.map(c => (
                <option key={c.id} value={c.nome}>{c.nome}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Ocorrências</label>
            <div className="space-y-2">
              {motivosOcorrencia.length > 0 && (
                <div className="flex flex-wrap gap-2">
                  {motivosOcorrencia.map((motivo, idx) => (
                    <button
                      key={idx}
                      type="button"
                      onClick={() => {
                        setFormCargaRecorrente(f => ({
                          ...f,
                          ocorrencias: f.ocorrencias.includes(motivo)
                            ? f.ocorrencias.filter(o => o !== motivo)
                            : [...f.ocorrencias, motivo]
                        }));
                      }}
                      className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
                        formCargaRecorrente.ocorrencias.includes(motivo)
                          ? 'bg-red-600 text-white'
                          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                    >
                      {motivo}
                    </button>
                  ))}
                </div>
              )}
              <input
                type="text"
                value={formCargaRecorrente.observacaoOcorrencia}
                onChange={(e) => setFormCargaRecorrente(f => ({ ...f, observacaoOcorrencia: e.target.value }))}
                placeholder="Observação sobre a ocorrência (opcional)"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
              {formCargaRecorrente.ocorrencias.length > 0 && (
                <p className="text-xs text-gray-500">
                  Selecionadas: {formCargaRecorrente.ocorrencias.join(', ')}
                </p>
              )}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Selecione os dias da semana *</label>
            <div className="grid grid-cols-7 gap-2">
              {['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'].map((dia) => (
                <button
                  key={dia}
                  type="button"
                  onClick={() => toggleDiaSemana(dia)}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    formCargaRecorrente.datasSelecionadas.includes(dia)
                      ? 'bg-green-600 text-white'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                >
                  {dia}
                </button>
              ))}
            </div>
            <p className="text-xs text-gray-500 mt-1">
              {formCargaRecorrente.datasSelecionadas.length > 0
                ? `${formCargaRecorrente.datasSelecionadas.length} dia(s) selecionado(s)`
                : 'Nenhum dia selecionado'}
            </p>
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <Button onClick={fecharModalCargaRecorrente} variant="secondary">Cancelar</Button>
            <Button onClick={salvarCargaRecorrente} variant="primary">Criar Cargas</Button>
          </div>
        </div>
      </Modal>

      {/* Modal de Gerenciamento de Grupo Recorrente */}
      <Modal
        isOpen={modalGrupoRecorrente.aberto}
        onClose={fecharModalGrupo}
        title="📅 Gerenciar Carga Recorrente"
        size="lg"
      >
        {modalGrupoRecorrente.grupo && (
          <div className="space-y-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="font-medium text-gray-900">{modalGrupoRecorrente.grupo.fornecedor}</p>
              <p className="text-sm text-gray-600">{modalGrupoRecorrente.grupo.produto || 'Produto não informado'}</p>
              <p className="text-xs text-gray-500 mt-1">Filial: {modalGrupoRecorrente.grupo.filial}</p>
            </div>

            <div>
              <h4 className="text-sm font-medium text-gray-700 mb-2">Cargas do Grupo</h4>
              <div className="space-y-2">
                {cargasGrupo.map((carga) => (
                  <div
                    key={carga.id}
                    className="flex justify-between items-center p-3 bg-white border border-gray-200 rounded-lg"
                  >
                    <div>
                      <p className="text-sm font-medium text-gray-900">
                        {new Date(carga.data_programada).toLocaleDateString('pt-BR', {
                          weekday: 'long',
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric'
                        })}
                      </p>
                      <p className="text-xs text-gray-500">Código: {carga.codigo}</p>
                      <p className="text-xs text-gray-500">Status: {carga.status}</p>
                    </div>
                    <button
                      onClick={() => excluirCargaIndividual(carga.id)}
                      className="text-red-600 hover:text-red-700 text-sm font-medium"
                    >
                      🗑️ Excluir
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex justify-end gap-2 pt-4 border-t">
              <Button onClick={fecharModalGrupo} variant="secondary">Fechar</Button>
              <Button
                onClick={excluirGrupoInteiro}
                variant="error"
              >
                🗑️ Excluir Grupo Inteiro
              </Button>
            </div>
          </div>
        )}
      </Modal>

      {/* Modal de Seleção de Conferente */}
      <Modal
        isOpen={modalConferenteAberto}
        onClose={fecharModalConferente}
        title="Selecionar Conferente"
      >
        <div className="space-y-4">
          <p className="text-sm text-gray-600">Selecione o conferente responsável por esta carga:</p>
          
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {conferentes.length === 0 ? (
              <p className="text-sm text-gray-500">Nenhum conferente cadastrado. Cadastre em Configurações &gt; Conferentes.</p>
            ) : (
              conferentes.map((conferente) => (
                <label
                  key={conferente.id}
                  className={`flex items-center p-3 border rounded-lg cursor-pointer hover:bg-gray-50 ${
                    conferenteSelecionado === conferente.nome ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
                  }`}
                >
                  <input
                    type="radio"
                    name="conferente"
                    value={conferente.nome}
                    checked={conferenteSelecionado === conferente.nome}
                    onChange={(e) => setConferenteSelecionado(e.target.value)}
                    className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  />
                  <div className="ml-3">
                    <span className="text-sm font-medium">{conferente.nome}</span>
                    {conferente.matricula && (
                      <span className="text-sm text-gray-500 ml-2">({conferente.matricula})</span>
                    )}
                  </div>
                </label>
              ))
            )}
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <Button onClick={fecharModalConferente} variant="secondary">
              Cancelar
            </Button>
            <Button onClick={salvarConferente} variant="primary">
              Salvar Conferente
            </Button>
          </div>
        </div>
      </Modal>

      {/* Modal de Documentos */}
      <Modal
        isOpen={modalDocumentosAberto}
        onClose={fecharModalDocumentos}
        title="📄 Documentos da Carga"
        size="md"
      >
        <div className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-blue-500">
            <p className="text-sm"><strong>Carga:</strong> {cargaSelecionadaDocumentos?.codigo}</p>
            <p className="text-sm"><strong>Fornecedor:</strong> {cargaSelecionadaDocumentos?.fornecedor}</p>
          </div>
          
          {cargaSelecionadaDocumentos?.documentos && cargaSelecionadaDocumentos.documentos.length > 0 ? (
            <div className="space-y-2">
              {cargaSelecionadaDocumentos.documentos.map((doc: any, index: number) => (
                <div key={index} className="flex items-center justify-between p-3 bg-white border rounded-lg hover:bg-gray-50">
                  <div className="flex items-center gap-3">
                    <span className="text-2xl">📄</span>
                    <div>
                      <p className="text-sm font-medium text-gray-900">{doc.nome || 'Documento sem nome'}</p>
                      {doc.tipo && (
                        <p className="text-xs text-gray-500">{doc.tipo}</p>
                      )}
                    </div>
                  </div>
                  {doc.url && (
                    <a
                      href={doc.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                    >
                      Abrir
                    </a>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-8">
              <span className="text-4xl">📭</span>
              <p className="text-sm text-gray-500 mt-2">Nenhum documento anexado a esta carga</p>
            </div>
          )}
          
          <div className="flex justify-end mt-4">
            <Button onClick={fecharModalDocumentos} variant="secondary">
              Fechar
            </Button>
          </div>
        </div>
      </Modal>

      {/* Modal de Nova Carga Manual */}
      <Modal
        isOpen={modalCargaManual}
        onClose={fecharModalCargaManual}
        title="🚛 Nova Carga"
        size="lg"
      >
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Fornecedor *</label>
              <input
                type="text"
                value={formCargaManual.fornecedor}
                onChange={(e) => setFormCargaManual(f => ({ ...f, fornecedor: e.target.value }))}
                placeholder="Nome do fornecedor"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
              <select
                value={formCargaManual.status}
                onChange={(e) => setFormCargaManual(f => ({ ...f, status: e.target.value }))}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="Não chegou">Não chegou</option>
                <option value="Chegou">Chegou</option>
                <option value="Descarregando">Descarregando</option>
                <option value="Finalizado">Finalizado</option>
                <option value="Cancelado">Cancelado</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Mercadorias Enviadas</label>
            <textarea
              value={formCargaManual.mercadorias}
              onChange={(e) => setFormCargaManual(f => ({ ...f, mercadorias: e.target.value }))}
              placeholder="Descrição das mercadorias enviadas"
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Peso Estimado (kg) *</label>
              <input
                type="number"
                step="0.01"
                value={formCargaManual.peso}
                onChange={(e) => setFormCargaManual(f => ({ ...f, peso: e.target.value }))}
                placeholder="0"
                min="0"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Volume Estimado *</label>
              <input
                type="number"
                value={formCargaManual.volume}
                onChange={(e) => setFormCargaManual(f => ({ ...f, volume: e.target.value }))}
                placeholder="0"
                min="0"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Data Desejada *</label>
              <input
                type="date"
                value={formCargaManual.dataProgramada}
                onChange={(e) => setFormCargaManual(f => ({ ...f, dataProgramada: e.target.value }))}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Prioridade</label>
              <select
                value={formCargaManual.prioridade}
                onChange={(e) => setFormCargaManual(f => ({ ...f, prioridade: parseInt(e.target.value) }))}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="1">1 - Alta</option>
                <option value="2">2 - Média Alta</option>
                <option value="3">3 - Média</option>
                <option value="4">4 - Média Baixa</option>
                <option value="5">5 - Baixa</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Conferente</label>
              <select
                value={formCargaManual.conferente}
                onChange={(e) => setFormCargaManual(f => ({ ...f, conferente: e.target.value }))}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Não definido</option>
                {conferentes.map(c => (
                  <option key={c.id} value={c.nome}>{c.nome}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Carga</label>
              <select
                value={formCargaManual.tipoCarga}
                onChange={(e) => setFormCargaManual(f => ({ ...f, tipoCarga: e.target.value }))}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="PALETIZADO">Paletizado</option>
                <option value="BATIDO">Batido</option>
                <option value="MISTO">Misto</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Produto</label>
            <div className="flex flex-wrap gap-4 mt-2">
              <label className="flex items-center">
                <input
                  type="radio"
                  name="tipoProdutoManual"
                  value="SECOS"
                  checked={formCargaManual.tipoProduto === 'SECOS'}
                  onChange={(e) => setFormCargaManual(f => ({ ...f, tipoProduto: e.target.value }))}
                  className="mr-2"
                />
                SECOS
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="tipoProdutoManual"
                  value="REFRIGERADOS"
                  checked={formCargaManual.tipoProduto === 'REFRIGERADOS'}
                  onChange={(e) => setFormCargaManual(f => ({ ...f, tipoProduto: e.target.value }))}
                  className="mr-2"
                />
                REFRIGERADOS
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="tipoProdutoManual"
                  value="CONGELADOS"
                  checked={formCargaManual.tipoProduto === 'CONGELADOS'}
                  onChange={(e) => setFormCargaManual(f => ({ ...f, tipoProduto: e.target.value }))}
                  className="mr-2"
                />
                CONGELADOS
              </label>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Ocorrências</label>
            <div className="flex flex-wrap gap-2">
              {motivosOcorrencia.map((motivo, idx) => (
                <button
                  key={idx}
                  type="button"
                  onClick={() => setFormCargaManual(f => ({
                    ...f,
                    ocorrencias: f.ocorrencias.includes(motivo)
                      ? f.ocorrencias.filter(o => o !== motivo)
                      : [...f.ocorrencias, motivo]
                  }))}
                  className={`px-3 py-1 text-xs rounded-full border transition-colors ${
                    formCargaManual.ocorrencias.includes(motivo)
                      ? 'bg-red-100 border-red-400 text-red-700'
                      : 'bg-gray-50 border-gray-300 text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  {motivo}
                </button>
              ))}
              {motivosOcorrencia.length === 0 && (
                <span className="text-sm text-gray-400">Nenhum motivo cadastrado</span>
              )}
            </div>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <Button onClick={fecharModalCargaManual} variant="secondary">Cancelar</Button>
            <Button onClick={salvarCargaManual} variant="primary">Criar Carga</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const CargasProtegido = () => (
  <AbaProtegida nomeAba="Cargas">
    <Cargas />
  </AbaProtegida>
);

export default CargasProtegido;
